const ABSOLUTE_MIN = 0;
const ABSOLUTE_MAX = 120;
const DEFAULT_STEP = 20;

/**
 * Escala padronizada para histórico de nível do silo (0–120 por padrão).
 * Se o nível máximo exceder 120, estende o eixo em passos de 20.
 */
export function getStandardizedLevelAxisRange(maxLevel = 0) {
  const level = Number(maxLevel) || 0;
  let max = ABSOLUTE_MAX;
  if (level > ABSOLUTE_MAX) {
    max = Math.ceil(level / DEFAULT_STEP) * DEFAULT_STEP;
  }
  return {
    min: ABSOLUTE_MIN,
    max,
    stepSize: DEFAULT_STEP,
  };
}

export const LEVEL_AXIS_ABSOLUTE_MIN = ABSOLUTE_MIN;
export const LEVEL_AXIS_ABSOLUTE_MAX = ABSOLUTE_MAX;
export const LEVEL_AXIS_DEFAULT_STEP = DEFAULT_STEP;
